import { Message } from 'element-ui'
import { downalod } from '@/worker/downloadUtil'

const state = {
  // {
  //     /**
  //      * 下载链接
  //      */
  //     url: 'https://xxx.xx.xx/xxx.xx',
  //     /**
  //      * 文件名称
  //      */
  //     filename: 'xxx.xx',
  //     /**
  //      * fetching 获取中
  //      * waiting 等待中
  //      * complete 完成
  //      * error 错误
  //      */
  //     status: 'fetching',
  //     /**
  //      * 下载进度 0 - 100
  //      */
  //     progress: 50,
  //     /**
  //      * 下载量
  //      */
  //     loaded: 0,
  //     /**
  //      * 总量
  //      */
  //     total: 0
  //   }
  downloadId: 0,
  downloadList: [
    // {
    //   url: 'http://localhost:8022/static/img/diploma_bg_origin.12ecfe4.jpg',
    //   filename: '图片图片',
    //   status: 'fetching',
    //   progress: 50,
    //   loaded: 105836,
    //   total: 5216432
    // }, {
    //   url: 'http://localhost:8022/static/img/diploma_bg_origin.12ecfe4.jpg',
    //   filename: '图片图片',
    //   status: 'fetching',
    //   progress: 50,
    //   loaded: 105836,
    //   total: 5216432
    // }
  ]
}

const mutations = {
  ADD_DOWNLOAD_ITEM(state, downloadItem) {
    downloadItem.id = state.downloadList.push(downloadItem)
  },
  REMOVE_DOWNLOAD_ITEM(state, downloadItem) {
    state.downloadList.splice(state.downloadList.indexOf(downloadItem), 1)
  }
}

const actions = {
  getNextDownloadId({ state }) {
    state.downloadId += 1
    return state.downloadId
  },
  async downloadFile({ commit, dispatch }, { url, filename }) {
    const uriFilename = url.split('/').pop()
    const suffix = uriFilename.split('.').pop()
    const downloadItem = {
      id: dispatch('getNextDownloadId'),
      url,
      filename,
      status: 'waiting',
      progress: 0
    }
    // 添加数据到state中
    commit('ADD_DOWNLOAD_ITEM', downloadItem)

    // 捕获错误
    try {
      Message.warning({
        message: `正在准备【${filename}】,请勿关闭浏览器标签！`,
        duration: 10 * 1000
      })

      const { blobUrl: downloadURL } = await downalod(downloadItem, e => {
        // 调整为下载中
        downloadItem.status = 'fetching'
        downloadItem.loaded = e.loaded
        downloadItem.total = e.total
        downloadItem.progress = Math.round((e.loaded / e.total) * 100)
      })

      // 下载完成
      downloadItem.status = 'complete'

      // 创建下载标签
      let a = document.createElement('a')
      document.body.appendChild(a)
      a.href = downloadURL
      a.download = `${filename}${suffix ? `.${suffix}` : ''}`
      a.target = '_blank'
      a.click()
      // 移除节点
      document.body.removeChild(a)
      // 释放掉引用地址
      window.URL.revokeObjectURL(downloadURL)

      // 删除已经下载完成的item
      commit('REMOVE_DOWNLOAD_ITEM')
    } catch (e) {
      Message.error({
        message: `文件【${filename}】下载失败，请重试！`,
        duration: 10 * 1000
      })
      downloadItem.status = 'error'
    }
  },
  /**
   * 公网 OSS 资源：先 GET /merchant/oss/public/downloadurl 再 window.open
   * 兼容相对路径（如 /merchant/upload/xxx.pdf）：需拼 publicDataHost，否则 new URL 抛错导致接口从未请求
   */
  async downloadFileForObjectURL({ dispatch, rootState }, { url, filename }) {
    let absoluteUrl = String(url || '')
      .trim()
      .split('?')[0]
    if (!absoluteUrl) {
      Message.error('下载地址为空')
      return
    }

    let urlObj
    try {
      urlObj = new URL(absoluteUrl)
    } catch (e) {
      let host = rootState.MerchantOssUpload && rootState.MerchantOssUpload.publicDataHost
      if (!host) {
        host = await dispatch('MerchantOssUpload/getPublicDataHost', {}, { root: true })
      }
      host = String(host || '').replace(/\/$/, '')
      const p = absoluteUrl.startsWith('/') ? absoluteUrl : `/${absoluteUrl}`
      if (!host) {
        Message.error('公共资源域名未加载，请刷新页面后重试')
        return
      }
      absoluteUrl = `${host}${p}`
      try {
        urlObj = new URL(absoluteUrl)
      } catch (err2) {
        Message.error('下载地址无效')
        return
      }
    }

    const pathname = urlObj.pathname
    const lastSeg = pathname.split('/').pop() || ''
    const dot = lastSeg.lastIndexOf('.')
    const suffix = dot > 0 ? lastSeg.slice(dot + 1).toLowerCase() : 'bin'

    const apiParams = { path: pathname, filename: `${filename}.${suffix}` }
    const downloadURL = await dispatch(
      'MerchantOssUpload/getPublicDownloadURL',
      apiParams,
      { root: true }
    )
    window.open(downloadURL, '_blank')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/download.js